import React, { useState, useEffect, useRef } from 'react';
import './App.scss';
import LightSwitch from './components/LightSwitch/LightSwitch.jsx';
import Header from './components/Header/Header.jsx';
import Contact from './components/Contact/Contact.jsx';
import ArrowToTop from './components/ArrowToTop/ArrowToTop.jsx';
import Footer from './components/Footer/Footer.jsx';
import Experiences from './components/Experiences/Experiences.jsx';
import Background from './components/Background/Background.jsx';
import RunningNumbers from './components/RunningNumbers/RunningNumbers.jsx';
import Navbar from './components/Navbar/Navbar.jsx';
import Skills from './components/Skills/Skills.jsx';
import Projects from './components/Projects/Projects.jsx';
import Dog from './components/Dog/Dog.jsx';
import { DogProvider } from './context/DogContext.jsx';

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from 'react-router-dom';

function App() {
  const [isDarkMode, setIsDarkMode] = useState(true);
  const [highlightedSkills, setHighlightedSkills] = useState([]);
  const skillConstraint = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    
    const timer = setTimeout(() => {
      document.body.style.overflow = '';
    }, 7800);

    return () => clearTimeout(timer);
  }, []);

  function changeDarkMode(mode) {
    console.log("mode", mode);
    
    setIsDarkMode(mode)
  }

  return (
    <DogProvider>
      <Router>
        <Routes>
          <Route path="/" element={
            <div className={"app-container " + (isDarkMode ? 'dark' : 'light')}>
              <Background isDarkMode={isDarkMode} />
              <LightSwitch changeDarkMode={changeDarkMode} />
              <Navbar isDarkMode={isDarkMode} />
              <Header />
              <RunningNumbers />
              <div className="content-container" ref={skillConstraint}>
                <Experiences isDarkMode={isDarkMode} onSkillsHover={setHighlightedSkills} />
                <Skills isDarkMode={isDarkMode} highlightedSkills={highlightedSkills} constraint={skillConstraint} />
              </div>
              <Projects />
              <Contact />
              <ArrowToTop />
              <Dog />
              <Footer />
            </div>
          } />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </DogProvider>
  );
}

export default App;
